// Global configuration for the all sites
const defaultConfig = {
  payment: {
    showAgreeTermsAndCondition: false,
    showZipCode: false,
  },
  disclaimer: {
    notShowIn: [
      "/es/instructions-page/new-passport",
      "/instructions-page/new-passport",
      "/es/instructions-page/passport-renewal",
      "/instructions-page/passport-renewal",
      "/es/instructions-page/lost-stolen-passport",
      "/instructions-page/lost-stolen-passport",
      "/es/instructions-page/lost-stolen-new-passport",
      "/instructions-page/lost-stolen-new-passport",
      "/es/instructions-page/passport-corrections",
      "/instructions-page/passport-corrections",
      "/es/thank-you",
      "/thank-you",
      "/es/verify-payment",
      "/verify-payment",
      "/es/instructions/photo-requirements",
      "/instructions/photo-requirements",
      "/es/instructions/passport-fees",
      "/instructions/passport-fees",
      "/es/instructions/proof-of-us-citizenship",
      "/instructions/proof-of-us-citizenship",
      "/es/instructions/proof-of-identity",
      "/instructions/proof-of-identity",
      "/image",
      "/es/image",
    ],
  },
  footer: {
    type: {
      default: "A",
      inPayment: "A",
      inFilling: "B", // Old D footer
    },
  },
  legal_effective_date_TC: `October 2025`,
  legal_effective_date_TC_es: `Octubre de 2025`,
  contact_hours: `Mon-Fri 5am - 7pm PT`,
  contact_hours_es: `Lun-Vie, de 5:00 h a 19:00 h PT`,
  country_name: `United States of America`,
  country_name_es: `Estados Unidos de América`,
};

module.exports = defaultConfig;
